var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeCancelTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE0AD",
    d: "M30.621.652v41.697l-14.333-5.51-15.637 5.51V.652z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD48D",
    d: "M30.621.652v41.697l-14.334-5.51L15.719.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11 20.22a.627.627 0 00-.89.88l3.08 3.112 9.796-9.828a.626.626 0 00-.886-.883l-8.907 8.935L9.11 20.22zm5.726 3.492a.625.625 0 10-.876.893l2.256 2.213 6.972-7.23a.624.624 0 10-.901-.868l-6.095 6.322-1.356-1.33z",
    fill: "#249995",
    stroke: "#249995",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }))));
}
export default SvgFreeCancelTick;